import { useContext, useEffect } from 'react';

import { BackendConfigContext } from '../utils/BackendInfrastructure/BackendConfigContext';
import { type BackendConfigJson } from '../utils/BackendInfrastructure/backendConfigJsonSchema';

function getEnvironmentPrefix(stage: BackendConfigJson['Stage']) {
  if (stage === 'prod') {
    return '';
  }

  return `[${stage.toUpperCase()}] `;
}

function getTitlePart(title: string | undefined) {
  if (title) {
    return `${title} | `;
  }

  return ``;
}

export function usePageTitle(title: string | undefined) {
  const backendConfig = useContext(BackendConfigContext);

  useEffect(() => {
    document.title = `${getEnvironmentPrefix(backendConfig.Stage)}${getTitlePart(title)}Viva SAP-Adapter`;
  }, [title, backendConfig.Stage]);
}
